export const createSingularLink = (paymentExternalID?: string) => {
  const {
    VITE_SINGULAR_LINK_BASE: singularPrefix,
    VITE_SINGULAR_CHECKOUT_PARAM: checkoutParam,
    VITE_APP_DOWNLOAD_URL: appDownloadUrl,
  } = import.meta.env;

  if (!paymentExternalID) {
    return appDownloadUrl;
  }

  const dlCheckoutParams = `${checkoutParam}${paymentExternalID}`;

  return `${singularPrefix}?_dl=${dlCheckoutParams}&_ddl=${dlCheckoutParams}&_smtype=3`;
};
